export default {
  title: 'ログイン画面',
  email: 'メールアドレス',
  emailPlaceholder: 'メールアドレスを入力してください',
  password: 'パスワード',
  passwordPlaceholder: 'パスワードを入力してください',
  rememberMe: 'ログイン情報を記憶する',
  forgotPassword: 'パスワードをお忘れの方',
  loginButton: 'ログイン',
  agreement: '読み、同意しました',
  serviceAgreement: '利用规约',
  privacyAgreement: 'プライバシー契約',
  and: 'と',
  emailRequired: 'メールアドレスを入力してください',
  passwordRequired: 'パスワードを入力してください',
  emailInvalid: '有効なメールアドレスを入力してください',
  passwordInvalid: 'パスワードは少なくとも8文字、文字と数字を含む必要があります',
  agreementRequired: '利用契約とプライバシー契約に同意してください',
  loading: 'ログイン中...',
  loginSuccess: 'ログイン成功',
  loginFailed: 'ログインに失敗しました',
};
